export default __webpack_public_path__ + "static/media/WallenDiaz3-1ETHM.c64352a4.mp4";